import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Chip,
  styled,
  Typography,
  Grid,
  TextField,
  MenuItem,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { MRT_ColumnDef } from "material-react-table";
import * as Yup from "yup";
import { StyledButton } from "../../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../../shared/components/form-builder/form-builder";
import { OptionType } from "../../../../shared/components/form-builder/form-config.model";
import CustomTable from "../../../../shared/components/table/custom-table";
import { cbLandingPageService } from "../tc-service/cb-landingpage.service";
import { CustomSelect } from "../../../../shared/components/inputfields/form-elements";
import { useFormActions } from "../../../../shared/hooks/form-builder.hooks";
import useRecordsStore, { Pagination } from "../../../../shared/hooks/useRecordStore";
import { getColumnsBySource } from "./cbLandingPageTable.config";
import { LoaderComponent } from "../../../../shared/components/loaders/page-loader";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import { TC_CREATE_ROUTE_CONFIG, TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import { dtrackItService } from "../tc-service/dtrackit.service";
import { useApi } from "../../../../shared/hooks/useApi";
import CBReasonDetails from "./cb-reason-deatils";
import { ETCAppConfig } from "../../../../shared/app-configs/etc-app-configs";
import { Utills } from "../../../../shared/app-configs/utilit";
import { StringValidation } from "../../../../shared/utils/custom-validation.utils";
import useNotification from "../../../../shared/hooks/useNotification";
import FilterListIcon from '@mui/icons-material/FilterList';

export const PageWrapper = styled("div")({
  padding: "0 25px 0px 25px",
  display: "grid",
  overflowY: "auto",
  flexDirection: "column",
  gap: "12px",
  flex: 1,
});

const CBLandingPage = () => {
  const formRef = useRef<any>(null);
  const navigate = useNavigate();
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [localSource, setLocalSource] = useState<string>("dTrackit");
  const { resetAllDatas } = useFormActions("")
  const { setDelayReason, setTCIssueDate, setEditTCInfo, cbLicensingCode, setTCStandardGOTS,setNewTCRequested } = useTransactionCertificateStore();
  const [submissionStatusOptions, setSubmissionStatusOptions] = useState([]);
  const [standardOptions, setStandardOptions] = useState([]);
  const { notify } = useNotification();
  const isCbUser = cbLicensingCode.startsWith("CB");
  const sourceOptions: OptionType[] = [
    { label: "TC (dTrackit)", value: "dTrackit" },
    // { label: "TC (historical)", value: "historical" }  
  ];
  const getTCSubmissionStatus = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_SUBMISSION_STATUS_V4,
        { tcCbLicensingCode: cbLicensingCode }
      );
  
      const result = Array.isArray(response.data)
  ? response.data
      .filter((t: any) => t && t.trim() !== "")
      .map((t: any) => ({ value: t, label: t }))
  : [];
  
      setSubmissionStatusOptions(result);
    } catch (err) {
      notify("Error fetching TC Submission Status", "error");
      Utills.cl(`Error in Fetching TC Submission Status ${err}`);
    }
  };


  const getTCStandard = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_TC_STANDARD_V4,
        { tcCbLicensingCode: cbLicensingCode }
      );
  
      const result = Array.isArray(response.data?.response)
        ? response.data.response.map((t: any) => ({ value: t, label: t }))
        : [];

  
      setStandardOptions(result);
    } catch (err) {
      notify("Error fetching TC Standard", "error");
      Utills.cl(`Error in Fetching TC Standard ${err}`);
    }
  };
  const links: OptionType[] = [
    { label: "TP1", value: "item1" },
    { label: "TP2", value: "item2" },
  ];
  const { executeGet } = useApi();

  const [singleValue, setSingleValue] = React.useState<string | number>("");

  const {
    dTrackitData,
    dTrackitDataV4,
    historicalData,
    eTrackitData,
    fetchRecords,
    selectedSource,
    setSelectedSource,
    isLoading,
  } = useRecordsStore();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0)
  const filteredData =
  selectedSource === 'dTrackit' ? dTrackitData :
  selectedSource === 'dTrackitV4' ? dTrackitDataV4 :
  selectedSource === 'historical' ? historicalData :
  eTrackitData;
  const columns = useMemo(() => getColumnsBySource(selectedSource),
    [selectedSource]);
  const [countries, setCountries] = useState([]);

  const [isResetEnabled, setResetEnable] = useState(false);

  const getCountry = async () => {
    try {
      let apiEndpoint = "";
      // On this V4 page, default to V4 endpoint for TC unless explicitly using historical/eTrackit
      if (selectedSource === "historical") {
        apiEndpoint = TCAppConfig.GET_HISTORICAL_COUNTRY;
      } else if (selectedSource === "eTrackit") {
        apiEndpoint = ETCAppConfig.GET_CB_LANDING_PAGE_COUNTRIES;
      } else {
        apiEndpoint = TCAppConfig.GET_CB_LANDING_PAGE_COUNTRIES_V4;
      }
      //456 cb-trc
      const response: any = await executeGet(apiEndpoint, { tcCbLicensingCode: cbLicensingCode });
      Utills.cl(`getCountry result ${JSON.stringify(response)}`)
      const transformedData = response.data
        .filter((t: any) => t !== "") // Filter out empty strings
        .map((t: any) => ({ value: t, label: t }));
      Utills.cl(`transformedData countries ${transformedData}`)
      setCountries(transformedData);
      // Utills.cl(`getCountry ${countries}`)
    } catch (err) {
      Utills.cl(`Error in Fetching Countries ${err}`);
    }
  };

  const handleTCNOChange = (value: any) => {
    formRef.current.setFieldValue("tcNo", value == null ? "" : value.value);
  };
  const getTCNoforSearch = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ) => {
    try {
      const queryParams: Record<string, any> = {
        tcNo: type === "query" ? value : "",
        offset,
        name: type === "name" ? value : "",
        tcCbLicensingCode: cbLicensingCode,
      };
  
      const response: any = await executeGet(TCAppConfig.GET_TC_NO_v4, queryParams);
  
      // Check if API failed
      if (response?.data?.Failed) {
        console.warn("API Error:", response.data.Failed);
        return [];
      }
  
      // If no records
      if (!response?.data || response.data.no_of_records === 0) {
        return [];
      }
  
      // If response is valid
      if (Array.isArray(response.data.response)) {
        return response.data.response.map((item: any) => ({
          label: item,
          value: item,
        }));
      }
  
      return [];
    } catch (e) {
      console.error(`Error in Fetching TCNo ${e}`);
      return [];
    }
  };
  
  const onNewRequestTCClick = () => {
    setNewTCRequested(true)
    navigate("/v4/tc/create-tc/transaction-certificate")
  }
  useEffect(() => {
    const loadData = async () => {
      await fetchRecords({
        tcCbLicensingCode: cbLicensingCode,
        source: "dTrackitV4",
        pagination,
        rowCount,
        setRowCount
      });
    }      
    loadData();
  }, [pagination.pageIndex, pagination.pageSize, selectedSource]);
  useEffect(() => {
    if (cbLicensingCode) {
      setEditTCInfo({});
      setDelayReason(false);
      setTCIssueDate("");
      resetAllDatas();
      getTCSubmissionStatus();
      getTCStandard();
      setTCStandardGOTS(false);
    }
  }, [cbLicensingCode]);

  useEffect(() => {
    getCountry();
  }, [selectedSource]);

  const handlePageChange = useCallback(
    (newPagination: Pagination) => {
      setPagination({
        ...pagination,
        ...newPagination,
      });
    },
    [pagination, setPagination]
  );

  const formConfig = {
    pageName: "cb-landing-page",
    initialValues: {
      buyersCountry: [], // For multi-select
      startDate: null,
      endDate: null,
      tcStandard: [],
      source: "",
      submissionStatus: ""
    },
    validationSchema: Yup.object().shape({
      buyersCountry: Yup.array().nullable(),
      startDate: Yup.string().nullable(),
      endDate: Yup.string().nullable(),
      tcStandard: Yup.array().nullable(),
      source: Yup.string().nullable(),
      submissionStatus: Yup.string().nullable(),
    }),
    sections: [
      {
        fields: [
          {
            label: "Buyer's Country/Area",
            name: "buyersCountry",
            type: "select",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              size: "small",
              multiple: true,
              enableSearch: true,
              options: countries,
              placeholder: "Select Buyer's Country",
            },
          },
          // Start Date Field
          {
            label: "Issue Start Date",
            name: "startDate",
            type: "date",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Select Start Date",
            },
          },
          // End Date Field
          {
            label: "Issue End Date",
            name: "endDate",
            type: "date",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Select End Date",
            },
          },
          {
            label: "TC Number",
            name: "tcNo",
            type: "search",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Search TC Number.",
              onChange: handleTCNOChange,
              displayKey: "label",
              onSearch: (query: string, offset: number) => {
                const response = getTCNoforSearch(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Submission Status",
            name: "submissionStatus",
            type: "select",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              size: "small",
              multiple: false,
              options: submissionStatusOptions,
              placeholder: "Select Submission Status",
            },
          },
          {
            label: "TC Standard",
            name: "tcStandard",
            type: "select",
            gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
            required: false,
            props: {
              size: "small",
              multiple: true,
              options: standardOptions,
              placeholder: "Select TC Standard",
            },
          },
          // {
          //   label: "Source",
          //   name: "source",
          //   type: "select",
          //   gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },
          //   required: false,
          //   props: {
          //     size: "small",
          //     multiple: false,
          //     options: sourceOptions,
          //     value: localSource,
          //     onChange: (event: any) => {
          //       setLocalSource(event.target.value);
          //       setSelectedSource(event.target.value);
          //       formRef.current?.setFieldValue('source', event.target.value, false);
          //       checkFormValues();
          //     }
          //   },
          // }

        ],
      },
    ],
    handleSubmit: async (values: any) => {
      await getCBLandingPageRecords(values,1);
    },
  };

  const getCBLandingPageRecords = async (values: any,isReseted?:number) => {
    try {
      if(isReseted==1){
      const isEmpty = (val: any) => StringValidation.isNullOrEmpty(val);
      const allFieldsEmpty = [values.tcNo, values.submissionStatus, values.startDate, values.endDate].every(isEmpty) && (!values.buyersCountry?.length) && (!values.tcStandard?.length);

      if (allFieldsEmpty) {
        notify("Please fill at least one field", "error");
        return;
      }
    }

      await fetchRecords({
        tcCbLicensingCode: cbLicensingCode,
        startDate: values.startDate,
        endDate: values.endDate,
        tcNo: values.tcNo,
        submissionStatus: values.submissionStatus,
        buyersCountry: values.buyersCountry?.length > 0 ? JSON.stringify(values.buyersCountry) : undefined,
        tcStandard: values.tcStandard.length > 0 ? JSON.stringify(values.tcStandard) : undefined,
        source: selectedSource === 'suppliers' ? 'dTrackitV4' : selectedSource,
        pagination: pagination,
        rowCount: rowCount,
        setRowCount,
      });
      if(isReseted==1){
      setResetEnable(true)
      }
      else{
        setResetEnable(false)
      }
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const checkFormValues = () => {
    const currentValues = formRef.current?.values;
    if (currentValues) {
      const isAnyValueFilled = Object.values(currentValues).some(
        value => (Array.isArray(value) && value.length > 0) ||
          (value !== null && value !== "" && value !== undefined)
      );
      setIsSearchEnabled(isAnyValueFilled);
    }
  };

  const handleRowClick = (row: any) => {
    setNewTCRequested(false)
    // Utills.cl(row);
    // if (row.tcMetadataStatus === "Submitted") {
    //   navigate(`/v4/tc/submited-tc/base-details/${row.tcId}`);
    // } else {
    //   navigate(`v4/tc/tc-details/base-details/${row.tcId}`);
    // }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  const handleReset = async () => {
    formRef.current.resetForm();
    const params = {
      tcCbLicensingCode: cbLicensingCode,
      startDate: null,
      endDate: null,
      tcNo: null,
      buyersCountry: [],
      tcStandard: [],
      source: selectedSource,
      submissionStatus: null,
      pagination: pagination
    }
    
    setResetEnable(false)
    await getCBLandingPageRecords(params,0);
  }

  const handleSingleChange = (
    event: SelectChangeEvent<string | number | string[]>
  ) => {
    setSingleValue(event.target.value as string | number);
  };
  Utills.cl(columns, filteredData);

  return (
    <>
      <PageWrapper>
        <Typography variant="h6" gutterBottom align="center" fontWeight={"600"}>
           Transaction Certificate - Version 4.0
        </Typography>
        {isCbUser && <Box
          display="flex"
          justifyContent="center" // Align items to the end of the container
          alignItems="center" // Vertically center the button and select
          width="100%" // Make the box span the entire width
          mb="12px"
          gap={2} // Add gap for spacing between elements
        >
          <StyledButton
            onClick={onNewRequestTCClick}
            variant="contained"
            color="warning"
            sx={{ height: "40px", mb: 2 }} // Ensure consistent button height
          >
            Create New Transaction Certificate
          </StyledButton>

        </Box>
}
        <Box
          display="flex"
          alignItems="center"
          mb={2}
          sx={{
            backgroundColor: '#f5f5f5',
            padding: '12px 16px',
            borderRadius: '8px',
            border: '1px solid #e0e0e0'
          }}
        >
          <FilterListIcon 
            sx={{ 
              color: 'primary.main', 
              marginRight: '8px',
              fontSize: '20px'
            }} 
          />
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'text.secondary',
              fontWeight: 500
            }}
          >
            Use the filter options below to filter through the table for existing Transaction Certificates​.
          </Typography>
        </Box>

        <FormBuilder
          formConfig={formConfig}
          onSubmit={formConfig.handleSubmit}
          formRef={formRef}
        />
        {/* </Grid> */}

        <Grid
          item
          md={2}
          lg={2}
          display="flex"
          justifyContent={"flex-end"}
          alignItems="center"
        >
          <StyledButton onClick={handleSubmit}>Search</StyledButton>
          {isResetEnabled ?
            <StyledButton onClick={handleReset}>Reset</StyledButton>
            : null
          }
        </Grid>

        {/* </Grid> */}

        <CustomTable
          key={selectedSource}
          columns={columns}
          columnVisibility={selectedSource==="dTrackitV4"?{tcId:false}:{}}
          data={filteredData}
          title="TransactionData"
          enableTopToolbar={true}
          enableBottomToolbar={true}
          // enableColumnOrdering={false}
          paginations={pagination} // Pass current pagination state
          setPaginations={setPagination}
          rowCount={rowCount}
          isLoadingTodos={isLoading}
          onClickRow={handleRowClick}
          hiddenColumns={["tcParentMetadataStatus","tcId"]}
        />
      </PageWrapper>

    </>
  );
};

export default CBLandingPage;